import { LayaGL } from "../../layagl/LayaGL";
import { SpineMeshBase } from "./SpineMeshBase";
export class SpineWasmVirturalMesh extends SpineMeshBase {
    constructor(material) {
        super(material);
        this._renderElement2D = LayaGL.render2DRenderPassFactory.createRenderElement2D();
        this._renderElement2D.geometry = this.geo;
        this._renderElement2D.nodeCommonMap = ["BaseRender2D", "spine2D"];
    }
    destroy() {
        super.destroy();
        this._renderElement2D.destroy();
    }
}
